import {DynamicColorsType} from "../../../ui/color_models";

export type PartnerBase = {
  name: string;
  current_creditor: string;
  street_line_1: string;
  street_line_2: string;
  city: string;
  state: string;
  zipcode: string;
  country_code: string;
  phone_numbers: string[];
};

export interface PartnerDetails {
  partnerName: string;
  address: string;
  phoneNumber: string;
  email: string;
  appUrl: string;
  links: {[key: string]: string};
}

export interface PartnerUiSettings {
  logo_url: string;
  ui_settings: {
    favicon_url: string;
    phone_number: string;
    button_radius: string;
    colors: DynamicColorsType;
    links: {[key: string]: string};
    email: string;
  };
  app_url: string;
  colors: DynamicColorsType;
  partner_code: string;
  partner_id: string;
  name: string;
  address: string;
  max_start_date_days: number;
  pre_charge_off_dispute_enabled: boolean;
}

export enum PartnerDomain {
  BOUNCE_AI = "bounce_ai",
  HAPPY_MONEY = "happy_money",
  CONSUMER_FP = "consumer_fp",
}
